import { Button, FilterSearchBar, Table } from '@/components';
import { AttachEntityToInfrastructureCostModal } from '@/modules/Infrastructure/pages/InfrastructureCostPage/components/AttachEntityToInfrastructureCostModal';
import {
  companiesCountColumnConfig,
  statusColumnConfig,
  usersCountColumnConfig,
} from '@/utils';
import { ReactElement, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TabContext } from '../TabContainer';
import { TableRow } from '../Table/types';

interface OrganizationsTabProps {
  canCreate?: boolean;
  canAttachCost?: boolean;
  costId?: number;
}

export const OrganizationsTab = ({
  canCreate,
  canAttachCost,
  costId,
}: OrganizationsTabProps): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: organizations,
    isLoading: isLoadingOrganizations,
    page,
    onPageChange,
    handleSearchChange,
  } = useContext(TabContext);

  const routeChange = (row?: TableRow) => {
    const path = `/organizations/${row?.id}`;
    navigate(path);
  };

  const columns = [
    statusColumnConfig(),
    usersCountColumnConfig(),
    companiesCountColumnConfig(),
  ];

  return (
    <>
      <FilterSearchBar
        total={organizations?.totalRows || 0}
        title={t('organizations')}
        onSearch={handleSearchChange}
        variant={'secondary'}
        otherActions={
          <>
            {canCreate && (
              <Button /*onClick={} TODO: add action*/ variant="primary">
                {t('add')}
              </Button>
            )}
            {canAttachCost && costId && (
              <AttachEntityToInfrastructureCostModal
                costId={costId}
                context="organization"
              />
            )}
          </>
        }
      />
      <Table
        onRowClick={routeChange}
        columns={columns}
        rows={organizations?.items ?? []}
        isLoading={isLoadingOrganizations}
        noResultsLabel={t('no_companies_available')}
        withPagination
        totalItems={organizations?.totalRows}
        totalPages={organizations?.totalPages}
        currentPage={page}
        onPageChange={onPageChange}
      />
    </>
  );
};
